import { render, staticRenderFns } from "./DefaultMarkupPicker.vue?vue&type=template&id=0b8ac2e2&scoped=true&"
import script from "./DefaultMarkupPicker.vue?vue&type=script&lang=js&"
export * from "./DefaultMarkupPicker.vue?vue&type=script&lang=js&"
import style0 from "./DefaultMarkupPicker.vue?vue&type=style&index=0&id=0b8ac2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ac2e2",
  null
  
)

export default component.exports